import styled from 'styled-components';

const Root = styled.div`
    padding: 32px;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f5f8fb;
    box-sizing: border-box;
`;

const MainSection = styled.div`
    width: 974px;
    height: 606px;
    border-radius: 11px;
    box-shadow: 0 2px 5px 0 rgba(0,0,0, 0.14);
    background-color: #fbfbfb;
    display: flex;
    margin-top: 25px;
`;

const Footer = styled.div`
    margin-top: 25px;
    font-size: 16px;
    text-align: center;
    color: #414670;
    & a {
        color: #2196f3;
    }
`;

const FormSection = styled.form`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    flex: 6;
    height: 100%;
    border-top-left-radius: 11px;
    border-bottom-left-radius: 11px;
    flex-direction: column;
`;

const FlauntSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    flex: 4;
    flex-direction: column;
    position: relative;
    overflow: hidden;
`;

const FormTitle = styled.h1`
    font-size: 22px;
    line-height: 1.36;
    color: #2a3a74;
    margin: 0;
    font-weight: 500;
`;

const FormSubTitle = styled.h3`
    font-size: 16px;
    color: #414670;
    opacity: 0.5;
    margin-top: 6px;
    margin-bottom: 30px;
`;

const FlauntElements = styled.div`
    height: 260px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    margin-top: 138px;
`;

const FlauntTitle = styled.div`
    color: #23336e;
    font-size: 15px;
    line-height: 1.78;
    opacity: 0.85;
`;

const Loading = styled.img`
    height: 48px;
    width 48px;
`;

const RefreshButton = styled.div`
    display: flex;
    margin-top: 40px;
    font-size: 14px;
    align-items: center;
    cursor: pointer;
    & .SVGInline {
        margin-right: 10px;
        height: 15px;
    }
    &:hover {
        span.txt {
            text-decoration: underline;
        }
    }
`;

export const PartnerIcon = styled.img`
    height: 50px;
    width: 136px;
    margin-top: 31px;
`;

export {
    Root, 
    MainSection, 
    FormSection, 
    FlauntSection, 
    FormTitle,
    FormSubTitle,
    FlauntElements,
    FlauntTitle,
    Loading,
    RefreshButton,
    Footer
}